export default __webpack_public_path__ + "static/media/mega_FB.458d73f2.png";